import { render } from "./CustomSwitcher.vue?vue&type=template&id=52aa823a&scoped=true"
import script from "./CustomSwitcher.vue?vue&type=script&lang=js"
export * from "./CustomSwitcher.vue?vue&type=script&lang=js"

import "./CustomSwitcher.vue?vue&type=style&index=0&id=52aa823a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aa823a"]])

export default __exports__